import { z } from 'zod'

export const tbankConnectionResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  isSandbox: z.boolean(),
  boundTbankAccountId: z.string().nullable(),
  lastValidatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type TbankConnectionResponseDto = z.infer<typeof tbankConnectionResponseSchema>
